import { render } from "./PostComment.vue?vue&type=template&id=86db3496&scoped=true"
import script from "./PostComment.vue?vue&type=script&lang=js"
export * from "./PostComment.vue?vue&type=script&lang=js"

import "./post-comment.scss?vue&type=style&index=0&id=86db3496&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86db3496"]])

export default __exports__